type from = string | ReadonlyArray<string> | number | boolean | object;
export interface FromObject<T = from> {
  [param: string]: T | null | undefined;
}

// tslint:disable-next-line: no-any
export function emptyToNull(object: FromObject): any {
  Object.keys(object).forEach(_ => {
    if (object[_] != null) {
      if (typeof object[_] === 'object') {
        if (Array.isArray(object[_])) {
          object[_] = (object[_] as []).map(emptyToNull);
        } else {
          object[_] = emptyToNull(object[_] as FromObject);
        }
      } else {
        if (object[_] === '') {
          object[_] = null;
        }
      }
    }
  });
  return object;
}
